<template>
  <footer v-if="data.conflicts || solvedConflicts || data.errors" class="status__footer">
    <p v-if="!solvedConflicts && data.conflicts && !data.errors">
      {{ $t(`${namespace}.defaultText`) }} <span v-html="$t(`${namespace}.conflictLinesText`)" />
    </p>

    <p v-if="data.conflicts && data.errors">
      {{ $t(`${namespace}.defaultText`) }} <span v-html="$t(`${namespace}.conflictAndErrorLinesText`)" />
    </p>

    <p v-if="!data.conflicts && data.errors">
      {{ $t(`${namespace}.defaultText`) }} <span v-html="$t(`${namespace}.errorLinesText`)" />
    </p>

    <p v-if="solvedConflicts && !data.errors" v-html="solvedConflictsText" />
  </footer>
</template>

<script>
export default {
  name: 'StatusFooter',
  props: {
    data: {
      type: Object,
      required: true
    },
    payload: {
      type: Object,
      required: true
    },
    solvedConflicts: {
      type: Number,
      default: 0
    }
  },
  computed: {
    solvedConflictsText () {
      const UPDATED_REGISTERS = this.data.solvedConflictsArray.filter(item => item === 'update').length
      const ADDED_REGISTERS = this.data.solvedConflictsArray.filter(item => item === 'insert').length
      return this.$t(`${this.namespace}.solvedConflictLinesText`)
        .replace('[UPDATED_REGISTERS]', UPDATED_REGISTERS + this.data.updates)
        .replace('[ADDED_REGISTERS]', ADDED_REGISTERS + this.data.success)
    }
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.status.footer'
    }
  }
}
</script>

<style lang="scss" scoped>
.status__footer {
  background-color: $gray-1;
  padding: 24px;
  text-align: center;

  p {
    margin: 0;
  }
}
</style>
